require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-celebrity-chef-scott-pickett-is-the-face-of-melbournes-11.json") })
        }
      }, "path---news-celebrity-chef-scott-pickett-is-the-face-of-melbournes-11");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-celebrity-chef-scott-pickett-is-the-face-of-melbournes-11!./.cache/json/news-celebrity-chef-scott-pickett-is-the-face-of-melbournes-11.json
// module id = 800
// module chunks = 231608221292675